import { render, staticRenderFns } from "./PreMinting.vue?vue&type=template&id=18a89dc3&"
import script from "./PreMinting.vue?vue&type=script&lang=js&"
export * from "./PreMinting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports